import React from "react";
import "./Driver_Offers.css";

const Driver_Offers = () => {
  return (
    <section className="Driver_Offers">
      <div className="container">
        <div className="main_div">
          <div className="img_holder">
            <img src="/assets/images/offers/driver.jpeg" className="offerimg" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Driver_Offers;
